// extracted by mini-css-extract-plugin
module.exports = {"nonArcadeHeader":"article-header_nonArcadeHeader__sD4Fk"};